import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { X } from 'lucide-react';
import { DateField } from './DateField';

const SELECT = 'h-9 px-2 border border-slate-200 rounded-md text-sm bg-white min-w-0 w-full';

export const CATEGORY_OPTIONS = [
  { value: '', label: 'All activity' },
  { value: 'auth', label: 'Logins & sign-outs' },
  { value: 'failed_logins', label: 'Failed logins only' },
  { value: 'destructive', label: 'Deletions & wipes' },
  { value: 'account', label: 'Account changes' },
  { value: 'credentials', label: 'Password & PIN changes' },
  { value: 'data', label: 'Data edits' },
];

export const EMPTY_FILTERS = { category: '', companyId: '', role: '', user: '', ip: '', dateFrom: '', dateTo: '', q: '', since: '', sinceLabel: '' };

export const TimelineFilters = ({ filters, setFilters, options }) => {
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  const setVal = (k) => (v) => setFilters({ ...filters, [k]: v });
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="timeline-filters">
        <select className={SELECT} value={filters.category} onChange={set('category')} data-testid="filter-category">
          {CATEGORY_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <select className={SELECT} value={filters.companyId} onChange={set('companyId')} data-testid="filter-company">
          <option value="">All companies</option>
          <option value="__platform__">Platform (Super Admin)</option>
          {options.companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select className={SELECT} value={filters.role} onChange={set('role')} data-testid="filter-role">
          <option value="">All roles</option>
          {options.roles.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        <select className={SELECT} value={filters.user} onChange={set('user')} data-testid="filter-user">
          <option value="">All users</option>
          {options.users.map((u) => <option key={u.id} value={u.id}>{u.username} ({u.role})</option>)}
        </select>
        <Input className="h-9 font-mono" placeholder="IP address" value={filters.ip} onChange={set('ip')} data-testid="filter-ip" />
        <DateField value={filters.dateFrom} onChange={setVal('dateFrom')} placeholder="From date" testId="filter-date-from" />
        <DateField value={filters.dateTo} onChange={setVal('dateTo')} placeholder="To date" testId="filter-date-to" />
        <Input className="h-9" placeholder="Search name, bank, action…" value={filters.q} onChange={set('q')} data-testid="filter-search" />
      </div>
      {(filters.since || active) && (
        <div className="flex flex-wrap items-center gap-2">
          {filters.since && (
            <span className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-slate-800 text-white" data-testid="filter-since-chip">
              {filters.sinceLabel || 'Recent'}
              <button className="link-chip hover:text-red-300" onClick={() => setFilters({ ...filters, since: '', sinceLabel: '' })} data-testid="filter-since-clear" aria-label="Remove time filter">
                <X className="w-3 h-3" />
              </button>
            </span>
          )}
          {active && (
            <Button size="sm" variant="ghost" className="h-7 px-2 text-xs gap-1" onClick={() => setFilters(EMPTY_FILTERS)} data-testid="filter-clear">
              <X className="w-3.5 h-3.5" /> Clear all filters
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
